import { render, staticRenderFns } from "./AddVisitDetails.vue?vue&type=template&id=d4704dd0&scoped=true"
import script from "./AddVisitDetails.vue?vue&type=script&lang=js"
export * from "./AddVisitDetails.vue?vue&type=script&lang=js"
import style0 from "./AddVisitDetails.vue?vue&type=style&index=0&id=d4704dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4704dd0",
  null
  
)

export default component.exports